// frontend/modules/template/stores/context-script-store.ts
import { create } from 'zustand';
import { ContextScriptFilters } from '../types/context-script.types';
import {ContextScriptDTO} from "@/shared/api/model";

interface ContextScriptState {
    scripts: ContextScriptDTO[];
    filters: ContextScriptFilters;
    selectedScriptId?: string;
}

interface ContextScriptActions {
    setScripts: (scripts: ContextScriptDTO[]) => void;
    setFilters: (filters: Partial<ContextScriptFilters>) => void;
    clearFilters: () => void;
    setSelectedScriptId: (id?: string) => void;
}

export const useContextScriptStore = create<ContextScriptState & ContextScriptActions>((set) => ({
    // Initial state
    scripts: [],
    filters: {
        active: true,
    },
    selectedScriptId: undefined,

    // Actions
    setScripts: (scripts) => set({ scripts }),
    
    setFilters: (filters) => set((state) => ({
        filters: {
            ...state.filters,
            ...filters,
        }
    })),
    
    clearFilters: () => set({
        filters: {
            active: true,
        }
    }),
    
    setSelectedScriptId: (id) => set({ selectedScriptId: id }),
}));
